import { Pipe, PipeTransform } from '@angular/core';

import { Machine } from '../models/entities/machine.type';

@Pipe({
  name: 'locationFilter'
})
export class LocationFilterPipe implements PipeTransform {

  transform(locations: Machine[], filterString: string = ''): Machine[] {
    if (!locations || !filterString) {
			return locations;
		}

    return locations.filter(
      location =>
        location.Title?.toLowerCase().includes(filterString.toLowerCase()) ||
        location.PhysicalAddress?.toLowerCase().includes(filterString.toLowerCase()) ||
        location.Monitors?.some(mon => mon.MonitorTitle.toLowerCase().includes(filterString.toLowerCase()))
    );
  }
}
